<template>
  <b-modal
    id="gtpModal"
    size="xl"
    content-class="menu-bg-blue-transparent-modal gtp-track-modal"
    title="Ground Truth Point Tracking"
    hide-footer
   
    scrollable
  >
    <div class="float-right">
      <b-row>
        <b-col>
          <fa
            :icon="['fas', 'long-arrow-alt-up']"
            color="yellow"
            title="Medium Priority"
          />&nbsp;- Collected between 9 and 12 months ago.
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <fa
            :icon="['fas', 'long-arrow-alt-up']"
            color="red"
            title="Higher Priority"
          />&nbsp;- Collected more than one year ago.
        </b-col>
      </b-row>
    </div>
    <vue-bootstrap4-table
      :rows="gtpRows"
      :columns="gtpColumns"
      :config="config"
      :classes="classes"
    >
      <template slot="expand" slot-scope="props">
        <b-button variant="info" @click="getGTPSurvey(props.row.survey_id)">
          <span>
            <fa :icon="['fas', 'info-circle']" title="Details" />
          </span>
        </b-button>
      </template>
      <template slot="variant" slot-scope="props">
        <span v-if="props.row.variant == '2'">
          <fa
            :icon="['fas', 'long-arrow-alt-up']"
            color="red"
            size="1x"
            title="Higher Priority"
          />
        </span>
        <span v-if="props.row.variant == '1'">
          <fa
            :icon="['fas', 'long-arrow-alt-up']"
            color="yellow"
            size="1x"
            title="Medium Priority"
          />
        </span>
      </template>
    </vue-bootstrap4-table>
  </b-modal>
</template>
<style>
.gtp-track-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.gtp-track-modal table { color: #063c6d !important; text-shadow: none !important; }
.gtp-track-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.gtp-track-modal thead th a,
.gtp-track-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.gtp-track-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.gtp-track-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.gtp-track-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.gtp-track-modal .footer-pagination-row td,
.gtp-track-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
</style>
<script>
import axios from 'axios'
import VueBootstrap4Table from 'vue-bootstrap4-table'

export default {
  name: 'MMP_GTP_Tracking_ReportModal',
  components: {
    VueBootstrap4Table
  },
  props: ['gtpColumns', 'gtpRows'],
  data() {
    return {
      classes: {
        table: {
          'menu-bg-blue-transparent-modal': true
        }
      },
      config: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        show_refresh_button: false,
        show_reset_button: false
      }
    }
  },
  methods: {
    async getGTPSurvey(survey_id) {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/gtp_tracking/getGTPSurveys', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              survey_id: survey_id
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(content.errors)
            } else {
              if (content.length > 0) {
                this.$emit('updatedGTPDetailsRows', content)
                this.$emit('updatedCoordinates', {
                  lat: content[0].lat,
                  long: content[0].long
                })
                this.$emit('showDetailsModal')
              } else {
                this.$bvToast.toast('Error: No survey details found.', {
                  autoHideDelay: 7000,
                  title: 'GTP Tracking',
                  toaster: 'b-toaster-top-right'
                })
              }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    }
  }
}
</script>
